import { render, staticRenderFns } from "./Neighborhoods.vue?vue&type=template&id=7e18f53e&"
import script from "./Neighborhoods.vue?vue&type=script&lang=ts&"
export * from "./Neighborhoods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports